<template>
  <div id="detail" class="fullWdth">
    <remote-js
      ref="remoteJs"
      src="https://static.360buyimg.com/item/assets/address/area.js"
    ></remote-js>
    <div class="controlWdth">
      <el-breadcrumb
        style="padding-top: 20px; padding-bottom: 30px"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/goodslist' }"
          >全部商品</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span style="color: #272727">商品详情</span></el-breadcrumb-item
        >
      </el-breadcrumb>
      <el-row class="conter">
        <!-- <div class="top-circle">
                            <div class="mask"></div>
                            <div class="circle"></div>
                        </div>
                        <div class="bottom-circle">
                            <div class="mask"></div>
                            <div class="circle"></div>
                         </div> -->
        <el-col :span="10">
          <div class="goodsimg">
            <div class="img">
              <img
                v-lazy="detail.images_run[this.pickbanner]"
                :key="pickbanner"
                alt=""
                v-if="detail != ''"
                style="margin-bottom: 10px; max-width: 442px; max-height: 442px"
              />
            </div>

            <div style="wdith: 442px; position: relative; width: 442px">
              <span
                class="imgbtn"
                style="position: absolute; left: 0px"
                @click="bnnerleft()"
                :class="pickbanner == 0 ? 'unbtn' : ''"
              >
                <i class="el-icon-arrow-left"></i>
              </span>
              <span
                v-if="detail != ''"
                class="imgbtn"
                style="position: absolute; right: 0px"
                @click="bnnerright()"
                :class="
                  this.pickbanner + 1 == this.detail.images_run.length
                    ? 'unbtn'
                    : ''
                "
              >
                <i class="el-icon-arrow-right"></i>
              </span>
              <ul
                class="product_details_img_box"
                :class="showlist ? '' : 'evenly'"
              >
                <li
                  v-for="(item, index) in detail.images_run"
                  :key="item"
                  @mousemove="bannermove(index)"
                  v-if="index < 5 + imgindex && index >= imgindex"
                  :data="imgindex"
                >
                  <img
                    v-lazy="item"
                    onerror="src='/static/imgout2.png'"
                    alt=""
                    :class="index == pickbanner ? 'theme-bd' : ''"
                  />
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="product_details">
            <p
              class="goodsName ellipseal"
              style="text-align: left"
              :title="detail.name"
            >
              <span class="jd lager" v-show="detail.source == 1">优选</span>
              <span class="yx lager" v-show="detail.source == 6">严选</span>
              <span class="new lager" v-show="detail.source == 2">直充</span>
              <span class="rob lager" v-show="detail.source == 3">卡券</span>
              <span style="">{{ detail.name }}</span>
            </p>
            <p class="goodsid" v-if="$store.state.mallStockShow">
              <span 
                v-if="detail.stock_status === 1" 
                style="margin-right: 20px;" 
              >库存：{{ detail.stock_number }}</span>
              <span 
                v-if="detail.stock_member_status === 1 && $store.state.user_id !== '' && $store.state.user_id !== 'null'"
              >剩余兑换数：{{ detail.stock_member_number - detail.stock_member_count < 0 ? 0 : detail.stock_member_number - detail.stock_member_count }}</span>
            </p>
            <p class="goodsid">商品编号：{{ detail.code }}</p>
            <div
              class=""
              style="
                margin-top: 23px;
                background: #f5f5f5;
                border-radius: 1px;
                padding: 18px 10px 0px 10px;
                margin-bottom: 21px;
              "
            >
              <p class="goodsprice">
                <!-- <i class="iconfont iconjifen1 theme-col" style="font-size: 23px;vertical-align: baseline;"></i> -->
                <span
                  style="
                    display: inline-block;
                    height: 19px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #535353;
                    line-height: 19px;
                    margin-right: 17px;
                  "
                  >兑换价：</span
                >
                <span v-if="detail.points">
                  <span
                    class="theme-col"
                    style="
                    height: 40px;
                    font-size: 30px;
                    font-family: MicrosoftYaHei;
                    color: #e23130;
                    line-height: 40px;
                  "
                  >
                    {{ detail.points }}
                  </span>
                  <span
                    class="theme-col"
                    style="
                    height: 17px;
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #e23130;
                    line-height: 17px;
                    margin-top: 10px;
                  "
                    >{{ $store.state.name }}
                  </span>
                </span>
                <span v-if="detail.price_cash">
                  <span class="theme-col" v-if="detail.points">+</span
                  ><span class="theme-col">{{ detail.price_cash }}</span
                  ><span
                    style="
                    height: 17px;
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #e23130;
                    line-height: 17px;
                    margin-top: 10px;
                  "
                    >元</span
                  >
                </span>
                <span
                  v-if="$store.state.webInfo.market_status == 1"
                  style="
                    font-size: 13px;
                    text-decoration: line-through;
                    color: #7a7a7a;
                    margin-left: 15px;
                  "
                  >市场价:{{ detail.market_price }}元</span
                >
              </p>
              <!-- 京东地址 -->
              <div
                class="siteCont"
                style="display: flex; paddding-bottom: 21px"
                v-show="detail.source == 1"
              >
                <span
                  style="
                    align-items: center;
                    height: 19px;
                    font-size: 14px;
                    margin-right: 14px;
                    font-family: MicrosoftYaHei;
                    color: #535353;
                    line-height: 19px;
                  "
                >
                  配送至：</span
                >
                <div
                  class="sitsPop "
                  id="sitsPop"
                  @mouseenter="mouseEnter()"
                  @mouseleave="mouseLeave()"
                >
                  <!-- <div v-if="pop0==true" class="amendinfo"><span class="pop1">{{popAddress.area[0]}}</span><span class="pop2">{{popAddress.area[1]}}</span><span class="pop3">{{popAddress.area[2]}}</span><span class="pop4">{{popAddress.area[3]}}</span></div> -->
                  <div class="site">
                    <!-- <i class="el-icon-location"></i> -->

                    <span v-if="province1.length > 0">
                      {{ popAddressXq }} <i class="el-icon-arrow-down"></i
                    ></span>
                    <span v-else>
                      <!-- {{ popAddress.xq }} -->{{ popAddressXq }}
                    </span>
                    <!-- <i class="el-icon-arrow-down"></i> -->
                    <div class="sitelist noselect">
                      <div class="sitenav">
                        <span
                          :class="[
                            item ? 'spanBoder' : ' ',
                            index == td ? 'active1' : ''
                          ]"
                          v-for="(item, td) in popAddress.area"
                          :key="td"
                          @click="choseaddress(td)"
                          >{{ item }}
                          <i v-if="item" class="el-icon-arrow-down"></i>
                        </span>
                      </div>
                      <ul
                        style="    border-top: 2px solid rgb(226, 49, 48);"
                        v-loading="loading"
                      >
                        <li
                          v-for="(item, index) in sitelist"
                          :key="index"
                          @click="seletesite(item.id, item.name)"
                        >
                          {{ item.name }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- <div>
                  <el-select
                    v-model="province"
                    @change="choseProvince"
                    placeholder="省级地区"
                  >

                    <el-option
                      @blure="info(item.name)"
                      v-for="item in province1"
                      :key="item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-model="city"
                    @change="choseCity"
                    placeholder="市级地区"
                  >
                    <el-option
                      v-for="item in city1"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="county"
                    @change="choseBlock"
                    placeholder="区级地区"
                  >
                    <el-option
                      v-for="item in county1"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="this.four"
                    v-model="town"
                    @change="choseTown"
                    placeholder="乡镇级地区"
                  >
                    <el-option
                      v-for="item in town1"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  </div> -->
                </div>
              </div>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 20px; text-align: left"
            >
              <span
                style="margin-left: 10px; margin-right: 28px;cursor: default;"
              >
                数量：</span
              >
              <el-input-number
                v-if="detail.source != 2 && detail.source != 3"
                size="small"
                v-model="nums"
                @change="handleChange"
                :precision="0"
                :min="1"
                :max="999"
                style="width: 100px"
              ></el-input-number>
              <el-input-number
                v-if="detail.source == 2 || detail.source == 3"
                size="small"
                v-model="nums"
                @change="handleChange"
                :precision="0"
                :min="1"
                :max="1"
                style="width: 100px"
              ></el-input-number>
            </div>
            <div style="display:flex; margin-top: 30px;">
              <div
                style="
                text-align: left;
                line-height: 37px;

                display: flex;
              "
                v-if="
                  detail.source != 2 && detail.source != 3 && detail.status == 1
                "
              >
                <el-button
                  icon="cart"
                  style="font-size: 16px; margin-right: 20px"
                  class="bottom1"
                  @click="jdadd()"
                  :loading="paybtn"
                  v-if="detail.source == 1 && kucu == true"
                >
                  加入{{ $common.cardName().name }}</el-button
                >
                <el-button
                  style="
                  font-size: 16px;
                  color: #fff;
                  margin-right: 20px;
                  width: 168px;
                  height: 48px;
                  background: #b9b9b9;
                  border-radius: 6px;
                  border: 1px solid rgb(185, 185, 185);
                "
                  class="bottomhs"
                  v-if="detail.source == 1 && kucu == false"
                  >该地址暂无库存</el-button
                >
                <el-button
                  style="font-size: 16px; margin-right: 20px"
                  icon="cart"
                  class="bottom1"
                  @click="addcart()"
                  :loading="paybtn"
                  v-if="detail.source != 1"
                  >加入{{ $common.cardName().name }}</el-button
                >
                <div
                  class="sc"
                  @click="removecollect()"
                  v-if="is_collect != null"
                >
                  <img style="width: 24px" src="/static/img/sc.png" /><span
                    >收藏</span
                  >
                </div>
                <div
                  class="sc1"
                  @click="addcollect()"
                  v-if="is_collect == null"
                >
                  <img style="width: 24px" src="/static/img/sc1.png" /><span
                    >收藏</span
                  >
                </div>
              </div>
              <el-button
                v-if="detail.status == 0"
                style="
                  font-size: 16px;
                  background-color: #b5b5b5 !important;
                  color: #fff;
                  margin-right: 20px;
                "
                >商品已下架</el-button
              >

              <!-- v-if="(detail.source==2||detail.source==3)&&detail.status==1" -->
              <el-button
                class="bottom1"
                v-if="
                  (detail.source == 2 || detail.source == 3) &&
                    detail.status == 1
                "
                @click="addcart()"
                :loading="paybtn"
                >立即兑换</el-button
              >
            </div>
            <!-- <i class=" iconfont iconaixin1 theme-col" v-if="is_collect!=null" @click="removecollect()" style="font-size:22px;margin-left:25px"></i>
                                    <i class=" iconfont iconaixin theme-col" v-if="is_collect==null" @click="addcollect()" style="font-size:22px;margin-left:25px"></i> -->

            <!-- v-if="(detail.source==2||detail.source==3)&&detail.status==1" -->
            <!-- <div style="text-align: left;line-height: 37px;margin-top: 30px" >
                                    <el-button style="font-size:16px;" class="theme-bg" @click="addcart()" :loading="paybtn">立即兑换</el-button>
                                    <i class=" iconfont iconaixin1 theme-col" v-if="is_collect!=null" @click="removecollect()" style="font-size:22px;margin-left:25px"></i>
                                    <i class=" iconfont iconaixin theme-col" v-if="is_collect==null" @click="addcollect()" style="font-size:22px;margin-left:25px"></i>
                                </div> -->
            <!-- <div style="text-align: left;line-height: 37px;margin-top: 30px" v-if="detail.status==0">
                                    <button v-if="detail.status==0" style="font-size:16px;background-color: #b5b5b5!important;color:#fff">商品已下架</button>
                                </div> -->
          </div>
        </el-col>
      </el-row>
      <div style="margin-top: 30px">
        <div class="goodsdetail float-left">
          <!-- <span class="redline theme-bg"></span> -->
          <el-tabs type="border-card">
            <el-tab-pane label="商品详情">
              <p
                style="
                  margin: 28px 0 8px;
                  color: rgba(104, 104, 104, 1);
                  font-weight: 400;
                "
              >
                商品名称:{{ detail.name }}
              </p>
              <p
                style="
                  color: rgba(104, 104, 104, 1);
                  font-weight: 400;
                  margin-bottom: 10px;
                "
              >
                商品编号：{{ detail.code }}
              </p>
              <p v-html="detail.content"></p>
            </el-tab-pane>
            <!-- <el-tab-pane label="常见问题">配置管理</el-tab-pane> -->
          </el-tabs>
        </div>
        <div class="hotgoods float-right">
          <!-- <span class="redline theme-bg"></span> -->
          <p
            style="
              width: 330px;
              height: 47px;
              line-height: 47px;
              margin-bottom: 5px;
              background: #f5f5f5;
              border-bottom: 1px solid #e5e5e5;
              font-size: 18px;
              font-family: MicrosoftYaHei;
              color: #262626;
            "
          >
            <span class="greyline"></span>
            <strong>热门{{ $common.cardName().type ? "推荐" : "兑换" }}</strong>
            <!-- <span class="greyline"></span> -->
          </p>
          <ul style="width: 204px; box-sizing: border-box; margin: 0 auto">
            <li
              style=""
              v-for="(item, index) in hotgoods"
              :key="item.product_id"
            >
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'Detail', params: { id: item.product_id } }"
                style="padding-bottom: 5px"
              >
                <div
                  class="float-left"
                  style="
                    width: 184px;
                    margin: 10px;
                    margin-bottom: 5px;
                    height: 184px;
                    position: relative;
                  "
                >
                  <div class="numlist">
                    <span
                      style="
                        height: 14px;
                        font-size: 10px;
                        font-family: MicrosoftYaHei;
                        color: #ffffff;
                        line-height: 14px;
                      "
                      >TOP</span
                    ><br />
                    <span
                      style="
                        height: 16px;
                        position: relative;
                        top: -6px;
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: #ffffff;
                        line-height: 16px;
                      "
                      >{{ index + 1 }}</span
                    >
                  </div>
                  <img
                    v-lazy="item.image_url"
                    onerror="src='/static/imgout2.png'"
                    alt=""
                    style="height: 100%"
                    lazy
                  />
                </div>
                <div
                  class="float-left"
                  style="
                    margin: 0 auto;
                    padding: 10px;
                    padding-top: 0px;
                    box-sizing: border-box;
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #272727;
                    line-height: 24px;
                  "
                >
                  <div
                    class="ellipseal"
                    style="text-align: left"
                    :title="item.product_name"
                  >
                    <span class="jd lager" v-show="item.type == 1">优选</span>
                    <span class="yx lager" v-show="item.type == 6">严选</span>
                    <span class="new lager" v-show="item.type == 2">直充</span>
                    <span class="rob lager" v-show="item.type == 3">卡券</span>
                    {{ item.product_name }}
                  </div>
                  <div
                    style="
                      text-align: left;
                      margin-top: 10px;
                      padding-bottom: 5px;
                    "
                    class="theme-col"
                  >
                    <span style="font-size: 16px">
                      <span v-if="item.points">{{ item.points }}{{ $store.state.name }}</span>
                      <span class="theme-col" v-if="item.points">+</span>
                      <span class="theme-col">{{ item.price_cash }}</span>
                      <span
                        style="
                          height: 17px;
                          font-size: 13px;
                          font-family: MicrosoftYaHei;
                          color: #e23130;
                          line-height: 17px;
                          margin-top: 10px;
                        "
                      >
                        元
                      </span>
                    </span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>

        <div class="clear"></div>
      </div>
    </div>
    <div class="mask" v-if="login" @click="login = false"></div>
    <vLogin class="login" v-if="login" @hide="hideLogin"></vLogin>
    <el-dialog :visible.sync="showtips" width="430px" center>
      <div slot="title" class="tips-header">
        <div class="rect theme-bg"></div>
        <div class="dialog-title f-b">提示</div>
      </div>
      <div>
        <p style="text-align: center">
          已成功加入{{ $common.cardName().name }}，是否去{{
            $common.cardName().type ? "结算" : "兑换"
          }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showtips = false" class="tips-btn">取 消</el-button>
        <router-link :to="{ name: 'Cart' }">
          <el-button
            type="primary"
            @click="showtips = false"
            class="tips-btn"
            style="margin-left: 28px"
          >
            确 定
          </el-button>
        </router-link>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import vLogin from "@/common/login";
import Jsonp from "jsonp";
export default {
  components: {
    vLogin,
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src }
        });
      },
      props: {
        src: { type: String, required: true }
      }
    }
  },
  data() {
    return {
      loading: false,
      paybtn: false, //按钮等待
      login: false,
      pickbanner: 0, //轮播图
      imgindex: 0,
      detail: "",
      hotgoods: "", //热门商品
      showlist: true,
      nums: 1,
      is_collect: false, //是否收藏
      showtips: false,
      four: false,
      kucu: false,

      //京东地址
      index: 0,
      sitelist: [],
      province: "",
      provinceId: "",
      province1: [],
      city: "",
      cityId: "",
      city1: [],
      town: "",
      townId: "",
      town1: [],
      county: "",
      county1: [],
      pop0: true,
      popAddressXq: "",
      popAddress: this.$store.state.address,
      datass: [], //精品推荐
      phdatas: [] //排行推荐
    };
  },
  watch: {
    $route(to, form) {
      if (to.name == "Detail") {
        this.detail = "";
        this.getdatadetail();
      }
    },
    "$store.state.address.ti": function() {
      this.checkAddress();
    }
  },
  methods: {
    mouseEnter() {
      document.getElementById("sitsPop").classList.add("sitsPop-hover");
    },
    mouseLeave() {
      document.getElementById("sitsPop").classList.remove("sitsPop-hover");
    },
    //京东默认地址
    checkAddress: function() {
      this.province = parseInt(this.$store.state.address.id[0]);
      this.city = parseInt(this.$store.state.address.id[1]);
      this.county = parseInt(this.$store.state.address.id[2]);
      this.town = parseInt(this.$store.state.address.id[3]);
      if (this.$store.state.address.id[3] == "") {
        this.four = false;
      }
      this.getAddresslist();
    },
    getAddresslist: function() {
      var _this = this;
      // Jsonp('https://fts.jd.com/area/get?fid=' + this.province, null, (err, data) => {
      //   if (err) {
      //     return false
      //   }
      //   var arr = [
      //     {
      //       id: '0',
      //       name: '请选择地址'
      //     }
      //   ]
      //   data.forEach(item => {
      //     arr.push(item)
      //   })
      //   _this.city1 = arr
      //   _this.city = _this.$store.state.address.id[1]
      //   this.province = this.$store.state.address.id[0]
      // })
      // Jsonp('https://fts.jd.com/area/get?fid=' + this.city, null, (err, data) => {
      //   if (err) {
      //     return false
      //   }
      //   var arr = [
      //     {
      //       id: '0',
      //       name: '请选择地址'
      //     }
      //   ]
      //   data.forEach(item => {
      //     arr.push(item)
      //   })
      //   _this.county1 = arr
      //   this.county = this.$store.state.address.id[2]
      // })
      // Jsonp('https://fts.jd.com/area/get?fid=' + this.county, null, (err, data) => {
      //   if (err) {
      //     return false
      //   }
      //   if (data.length === 0) {
      //     this.four = false
      //   } else {
      //     this.four = true
      //     var arr = [
      //       {
      //         id: '0',
      //         name: '请选择地址'
      //       }
      //     ]
      //     data.forEach(item => {
      //       arr.push(item)
      //     })
      //     _this.town1 = arr
      //     this.town = this.$store.state.address.id[3]
      //   }
      // })
      //省
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province = this.$store.state.address.id[0];
            _this.province1 = res.data.data;
          }
        }
      );
      //市
      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city = _this.$store.state.address.id[1];
            console.log(this.city);
            _this.city1 = res.data.data;
          }
        }
      );
      //区
      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
            _this.county = this.$store.state.address.id[2];
          }
        }
      );
      // this.$api.get('sys/address', { id_example: this.$store.state.id_example, parent_id: this.province }, res => {
      //   if (res.data.code == 100) {
      //     _this.city1 = [];
      //     $.each(res.data.data, function(index, item) {
      //       var arr = { id: index, name: item };
      //       _this.city1.push(arr);
      //     });
      //   }
      // })
      // this.$api.get('sys/address', { id_example: this.$store.state.id_example, parent_id: this.city }, res => {
      //   if (res.data.code == 100) {
      //     _this.county1 = [];
      //     $.each(res.data.data, function(index, item) {
      //       var arr = { id: index, name: item };
      //       _this.county1.push(arr);
      //     });
      //   }
      // })
      // this.$api.get('sys/address',{ id_example: this.$store.state.id_example, parent_id: this.county }, res => {
      //   if (res.data.code == 100) {
      //     if (res.data.data == false) {
      //     } else {
      //       this.four = true;
      //     }
      //     _this.town1 = [];
      //     $.each(res.data.data, function(index, item) {
      //       var arr = { id: index, name: item };
      //       _this.town1.push(arr);
      //     });
      //   }
      // })
      this.getJdStock();
    },
    //省
    adddz: function(e) {
      this.name = "";
      this.tel = "";
      this.setess = "";
      this.checked = false;
      this.poptype = 1;
      this.add = true;
      this.province1 = [];
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.province = "";
      this.county = "";
      this.city = "";
      this.town = "";
      //   this.pop0 = false;
      var _this = this;
      this.kucu = false;

      // Jsonp('https://fts.jd.com/area/get?fid=4744', null, (err, data) => {
      //   if (err) {
      //     return this.$toast('获取地址失败')
      //   }
      //   let siteData = []
      //   for (let key in data) {
      //     if (key === '52993' || data[key].name === '港澳') {
      //       continue
      //     }
      //     if (key === '32' || data[key].name === '台湾') {
      //       continue
      //     }
      //     if (key === '84' || data[key].name === '钓鱼岛') {
      //       continue
      //     }
      //     if (key === '53283' || data[key].name === '海外') {
      //       break
      //     } else {
      //       siteData.push(data[key])
      //     }
      //   }
      //   _this.province1 = siteData
      // })
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            _this.province1 = res.data.data;
          }
        }
      );
      //   this.$api.get(
      //     "sys/address",
      //     { id_example: this.$store.state.id_example, parent_id: 0 },
      //     res => {
      //       if (res.data.code == 100) {
      //         _this.province1 = [];
      //         $.each(res.data.data, function(index, item) {
      //           var arr = { id: index, name: item };
      //           _this.province1.push(arr);
      //         });
      //       }
      //     }
      //   );
    },
    // 市
    choseProvince: function() {
      this.city1 = [];
      this.town1 = [];
      this.county1 = [];
      this.city = "";
      this.county = "";
      this.town = "";
      this.pop0 = false;
      var _this = this;
      this.kucu = false;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.province, null, (err, data) => {
      //   if (err) {
      //     return this.$toast('获取地址失败')
      //   }
      //   _this.city1 = data
      // })

      this.$api.post(
        "address/address/getCity",
        { id_example: this.$store.state.id_example, area_id: this.province },
        res => {
          if (res.data.code == 100) {
            _this.city1 = res.data.data;
          }
        }
      );
    },
    // 区
    choseCity: function() {
      this.town1 = [];
      this.county1 = [];
      this.town = "";
      this.county = "";
      this.pop0 = false;
      var _this = this;
      this.kucu = false;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.city, null, (err, data) => {
      //   if (err) {
      //     return this.$toast('获取地址失败')
      //   }
      //   _this.county1 = data
      // })

      this.$api.post(
        "address/address/getCounty",
        { id_example: this.$store.state.id_example, area_id: this.city },
        res => {
          if (res.data.code == 100) {
            _this.county1 = res.data.data;
          }
        }
      );
    },
    // 县
    choseBlock: function() {
      this.town1 = [];
      this.town = "";
      this.ctown = "";
      this.pop0 = false;
      var _this = this;

      // Jsonp('https://fts.jd.com/area/get?fid=' + this.county, null, (err, data) => {
      //   if (err) {
      //     return this.$toast('获取地址失败')
      //   }
      //   if (data.length === 0) {
      //     this.four = false
      //   } else {
      //     this.four = true
      //     _this.town1 = data
      //   }
      //   this.$api.post(
      //     '/product/jd/stock',
      //     {
      //       id_example: this.$store.state.id_example,
      //       id_province: this.province,
      //       id_city: this.city,
      //       id_county: this.county,
      //       id_product: this.detail.id_spro
      //     },
      //     res => {
      //       if (res.data.code == 100) {
      //         if (res.data.data[0].desc == '有货') {
      //           this.kucu = true
      //         } else if (res.data.data[0].desc == '无货') {
      //           this.kucu = false
      //         }
      //       }
      //     }
      //   )
      // })
      this.$api.post(
        "address/address/getTown",
        { id_example: this.$store.state.id_example, area_id: this.county },
        res => {
          if (res.data.code == 100) {
            if (res.data.data == false) {
              this.four = false;
              this.getJdStock();
            } else {
              this.four = true;
            }
            _this.town1 = res.data.data;
          }
        }
      );

      //   this.$api.get(
      //     "sys/address",
      //     { id_example: this.$store.state.id_example, parent_id: this.county },
      //     res => {
      //       if (res.data.code == 100) {
      //         if (res.data.data == false) {
      //           this.four = false;
      //         } else {
      //           this.four = true;
      //         }
      //         _this.town1 = [];
      //         $.each(res.data.data, function(index, item) {
      //           var arr = { id: index, name: item };
      //           _this.town1.push(arr);
      //         });
      //     this.$api.post('/product/jd/stockrpc',{
      //                 id_example:this.$store.state.id_example,
      //                 id_province:this.province,
      //                 id_city:this.city,
      //                 id_county:this.county,
      //                 id_product:this.detail.id
      //             },res=>{
      //                 if(res.data.code==100){
      //                     if(res.data.data[0].result == '有货'){
      //                         this.kucu=true
      //                     }else if(res.data.data[0].result == '无货'){
      //                         this.kucu=false
      //                     }
      //                 }
      //             })
      //       }
      //     }
      //   );
    },
    //库存
    choseTown: function() {
      this.getJdStock();
    },
    getJdStock() {
      console.log(this.city);
      this.$api.post(
        "/product/jd/stock",
        {
          id_example: this.$store.state.id_example,
          id_province: this.province,
          id_city: this.city,
          id_county: this.county,
          id_product: this.detail.id_spro
        },
        res => {
          if (res.data.code == 100) {
            if (res.data.data[0].desc == "有货") {
              this.kucu = true;
            } else if (res.data.data[0].desc == "无货") {
              this.kucu = false;
            }
          }
        }
      );
    },
    bannermove(index) {
      this.pickbanner = index;
    },
    bnnerleft() {
      this.pickbanner == 0
        ? (this.pickbanner = this.pickbanner)
        : this.pickbanner--;
      this.imgindex == 0 ? (this.imgindex = this.imgindex) : this.imgindex--;
    },
    bnnerright() {
      this.pickbanner + 1 == this.detail.images_run.length
        ? (this.pickbanner = this.pickbanner)
        : this.pickbanner++;
      this.detail.images_run.length - 6 < this.imgindex
        ? (this.imgindex = this.imgindex)
        : this.imgindex++;
    },
    handleChange(value) {
      console.log(value);
    },
    jdadd() {
      if (this.paybtn == false) {
        //京东下单
        if (
          this.$store.state.user_id == "" ||
          this.$store.state.user_id == "null"
        ) {
          this.$alert("用户未登录请先登录", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.login = true;
              this.paybtn = false;
            }
          });
          return false;
        }
        if (this.province == "" && this.province1 != "") {
          this.$alert("请填写完整地址", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
          return false;
        }
        if (this.city == "" && this.city1 != "") {
          this.$alert("请填写完整地址", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
          return false;
        }
        if (this.county == "" && this.county1 != "") {
          this.$alert("请填写完整地址", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
          return false;
        }
        if (this.town == "" && this.town1 != "") {
          this.$alert("请填写完整地址", "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
          return false;
        }
        this.addcart();
      }
    },
    addcart() {
      if (this.paybtn == false) {
        this.paybtn = true;
        if (
          this.$store.state.user_id == "" ||
          this.$store.state.user_id == "null"
        ) {
          this.$alert("用户未登录请先登录", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.login = true;
            }
          });
        }
        var status;
        this.detail.source == 2 || this.detail.source == 3
          ? (status = -1)
          : (status = 1);
        this.$api.post(
          "user/cart/add",
          {
            id_example: this.$store.state.id_example,
            token_user: this.$store.state.user_id,
            id_product: this.detail.id,
            number: this.nums,
            status: status
          },
          res => {
            if (res.data.code == 100) {
              this.$store.commit("cartnum");
              if (status == 1) {
                this.showtips = true;
              } else {
                this.payorder(res.data.data);
              }
            } else if (
              res.data.data == "登录超时" &&
              this.$store.state.user_id != "null"
            ) {
              this.$alert("登录过期请重新登录", "提示", {
                confirmButtonText: "确定",
                callback: action => {
                  this.login = true;
                }
              });
            }
            this.paybtn = false;
          }
        );
      }
    },
    getdatadetail() {
      //获取商品详情
      this.$api.get(
        "product/detail",
        {
          id_example: this.$store.state.id_example,
          user_id: this.$store.state.userinfo.user_id,
          id_product: this.$route.params.id
        },
        res => {
          if (res.data.code == 100) {
            this.detail = res.data.data;
            res.data.data.images_run.length < 6
              ? (this.showlist = true)
              : (this.showlist = false);
            res.data.data.is_collect != null
              ? (this.is_collect = res.data.data.is_collect)
              : (this.is_collect = null);
            if (
              res.data.data.source != 2 &&
              res.data.data.source != 3 &&
              res.data.data.source != 5
            ) {
              this.checkAddress();
              this.adddz();
              console.log(this.popAddress);
              this.popAddressXq = this.popAddress.xq.replace(/请选择/, "");
            }
          } else {
            this.$message({
              message: res.data.message,
              duration: 1500,
              center: true
            });
            this.$router.push({ name: "Home" });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    getgoodslist() {
      //获取推荐商品列表
      this.$api.get(
        "product/hot",
        {
          id_example: this.$store.state.id_example
        },
        res => {
          this.hotgoods = res.data.data;
        }
      );
    },
    addcollect() {
      //收藏商品
      this.$api.post(
        "user/collection/add",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_product: this.detail.id
        },
        res => {
          if (res.data.code == 100) {
            this.is_collect = true;
            this.$message({
              message: "已成功加入收藏",
              duration: 1500,
              center: true
            });
          } else {
            this.$alert("用户未登录请先登录", "提示", {
              confirmButtonText: "确定",
              callback: action => {
                this.login = true;
              }
            });
          }
        }
      );
    },
    //移除收藏
    removecollect() {
      this.$api.post(
        "user/collection/delete",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          id_cocollection: this.is_collect
        },
        res => {
          if (res.data.code == 100) {
            this.is_collect = null;
            this.$message({
              message: "已取消收藏",
              duration: 1500,
              center: true
            });
          }
        }
      );
    },
    //虚拟商品下单
    payorder(id) {
      this.$api.get(
        "order/cart/create",
        {
          id_example: this.$store.state.id_example,
          token_user: this.$store.state.user_id,
          terminal: "pc",
          id_cart: id
        },
        res => {
          if (res.data.code == 100) {
            this.$router.push({
              name: "AffirmOrder",
              params: { id_cfir: res.data.data.id_cfir }
            });
          } else if (res.data.code == "-200") {
            this.$confirm("积分不足请兑换积分", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.$router.push({
                  name: "Buypoints",
                  params: { points: res.data.message, goodid: this.detail.id }
                });
              })
              .catch(() => {});
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定",
              callback: action => {}
            });
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    },
    hideLogin() {
      this.login = false;
    },

    // 选择地址
    choseaddress: function(index) {
      console.log(index);
      console.log(this.index);
      console.log(this.popAddress.area);
      this.loading = true;
      // this.popAddress.area.forEach((element,i) => {
      //  if(i>index){
      //    this.popAddress.area[index+1]=''
      //  }
      // });
      if (this.index == index) {
        return false;
      }
      this.index = index;

      var id = 0;
      switch (this.index) {
        case 0:
          id = 4744;
          break;
        case 1:
          id = this.popAddress.id[0];
          break;
        case 2:
          id = this.popAddress.id[1];
          break;
        case 3:
          id = this.popAddress.id[2];
          break;
      }
      var _this = this;
      // Jsonp('https://fts.jd.com/area/get?fid=' + id, null, (err, data) => {
      //      if (err) {
      //        return this.$toast('获取地址失败');
      //      }
      //       _this.sitelist=data;
      //    });
      if (this.index == 0) {
        this.kucu = false;
        this.$api.post(
          "address/address/getProvince",
          { id_example: this.$store.state.id_example, parent_id: 0 },
          res => {
            if (res.data.code == 100) {
              this.loading = false;
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 1) {
        this.kucu = false;
        this.$api.post(
          "address/address/getCity",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            this.loading = false;
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 2) {
        this.$api.post(
          "address/address/getCounty",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.loading = false;
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 3) {
        this.$api.post(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.loading = false;
              this.sitelist = res.data.data;
              console.log(res.data.data, er);
            }
          }
        );
      }
    },
    seletesite: function(id, name) {
      console.log(id, name);
      console.log(this.index);
      this.loading = true;
      switch (this.index) {
        case 0:
          this.popAddress.id = [id, 0, 0, 0];
          this.popAddress.area = [name, "请选择", "", ""];
          this.index++;
          break;
        case 1:
          if (this.popAddress.id[0] == id) {
            return false;
          }
          this.popAddress.id[1] = id;
          this.popAddress.area[1] = name;
          this.popAddress.id[2] = "";
          this.popAddress.area[2] = "请选择";
          this.popAddress.id[3] = "";
          this.popAddress.area[3] = "";
          this.index++;
          break;
        case 2:
          if (this.popAddress.id[1] == id) {
            return false;
          }
          this.popAddress.id[2] = id;
          this.popAddress.ti++;
          this.popAddress.area[2] = name;
          this.popAddress.id[3] = "";
          this.popAddress.area[3] = "请选择";
          this.index++;
          break;
        case 3:
          if (this.popAddress.id[2] == id) {
            return false;
          }
          if (name == this.popAddress.area[2]) {
            break;
          }
          this.popAddress.id[3] = id;
          this.popAddress.ti++;
          this.popAddress.area[3] = name;
          this.index++;
          break;
      }
      var _this = this;
      if (this.index == 1) {
        this.kucu = false;
        this.$api.post(
          "address/address/getCity",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.loading = false;
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 2) {
        this.kucu = false;

        this.$api.post(
          "address/address/getCounty",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            if (res.data.code == 100) {
              this.loading = false;
              this.sitelist = res.data.data;
            }
          }
        );
      }
      if (this.index == 3) {
        this.kucu = false;
        this.$api.post(
          "address/address/getTown",
          { id_example: this.$store.state.id_example, area_id: id },
          res => {
            this.loading = false;
            if (res.data.code == 100) {
              this.sitelist = res.data.data;
              console.log(res.data.data, "er");
              if (res.data.data.length == 0) {
                this.popAddress.area[3] = "";
                this.index = 0;
                this.fistes(0);
                console.log(this.popAddress);
                this.popAddress.xq = this.popAddress.xq.substring(
                  0,
                  this.popAddress.xq.length - 3
                );
                this.popAddressXq = this.popAddress.xq;
                document
                  .getElementById("sitsPop")
                  .classList.remove("sitsPop-hover");
                this.getJdStock();
              } else {
                this.popAddress.area[3] = "请选择";
              }
            }
          }
        );
      }
      if (this.index == 4) {
        this.kucu = false;
        console.log(this.$store.state.address.xq);
        this.$store.commit("setAddress", this.popAddress);
        this.popAddressXq = this.$store.state.address.xq;
        document.getElementById("sitsPop").classList.remove("sitsPop-hover");
        this.loading = false;
        this.index = 0;
        this.fistes(0);

        this.getJdStock();
      }
      console.log(this.sitelist);
      // this.$api.get(
      //   "sys/address",
      //   {
      //     id_example: this.$store.state.id_example,
      //     parent_id: id
      //   },
      //   res => {
      //     if (res.data.code == 100) {
      //       if ((res.data.data == false)) {
      //         if(this.index!=4){
      //           this.index=2
      //         }else{
      //           this.index=3
      //         }
      //         return false;
      //       }
      //       this.sitelist = [];
      //       var _this = this;
      //       $.each(res.data.data, function(index, item) {
      //         var arr = { id: index, name: item };
      //         _this.sitelist.push(arr);
      //       });
      //     }
      //   }
      // );
      this.$store.commit("setAddress", this.popAddress);
    },

    fistes: function(id) {
      // Jsonp('https://fts.jd.com/area/get?fid=4744', null, (err, data) => {
      //   if (err) {
      //        return this.$toast('获取地址失败');
      //      }
      //      let siteData=[]
      //      for (let key in data){
      //   if (key === '52993' || data[key].name === '港澳') {
      //     continue;
      //   }
      //   if (key === '32' || data[key].name === '台湾') {
      //     continue;
      //   }
      //   if (key === '84' || data[key].name === '钓鱼岛') {
      //     continue;
      //   }
      //         if (key === '53283' || data[key].name === '海外') {
      //             break;
      //         }else{
      //           siteData.push(data[key]);
      //         }
      //     }
      //   this.sitelist=siteData;
      // })
      this.kucu = false;
      this.$api.post(
        "address/address/getProvince",
        { id_example: this.$store.state.id_example, parent_id: 0 },
        res => {
          if (res.data.code == 100) {
            this.sitelist = res.data.data;
          }
        }
      );
      // this.$api.get(
      //   "sys/address",
      //   {
      //     id_example: this.$store.state.id_example,
      //     parent_id: id
      //   },
      //   res => {
      //     if (res.data.code == 100) {
      //       if ((res.data.data == false)) {
      //         return false;
      //       }
      //       this.sitelist = [];
      //       var _this = this;
      //       $.each(res.data.data, function(index, item) {
      //         var arr = { id: index, name: item };
      //         _this.sitelist.push(arr);
      //       });
      //     }
      //   }
      // );
    }
  },
  mounted() {
    this.fistes(0);
    this.getdatadetail();
    this.getgoodslist();
  }
};
</script>

<style lang="less" scoped>
.lager {
  width: 42px;
  height: 21px;
  line-height: 21px;
  font-size: 16px;
}
.sc {
  display: inline-block;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid #e23130;

  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #e23130;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    width: 100%;
    height: 17px;
    line-height: 17px;
  }
  &:hover {
    box-shadow: 1px 1px 12px 0px rgba(110, 110, 110, 0.17);
  }
}
.sc1 {
  display: inline-block;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid #b9b9b9;
  cursor: pointer;
  font-size: 13px;
  font-family: MicrosoftYaHei;
  color: #7a7a7a;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    width: 100%;
    height: 17px;
    line-height: 17px;
  }
  &:hover {
    box-shadow: 1px 1px 12px 0px rgba(110, 110, 110, 0.17);
  }
}

/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  border-top: solid 5px #e23130;
  color: #272727 !important;
  height: 100%;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  padding: 0px 40px;
  color: #272727;
  font-size: 18px;
}
/deep/ .el-tabs--border-card > .el-tabs__header {
  background: #f5f5f5;
  border: 1px solid #dfdfdf;
  border-top: none;
  border-right: none;
  border-left: none;
  margin: 0;
}
.bottom1 {
  width: 168px;
  height: 48px;
  background: rgba(226, 49, 48, 0.1);
  border-radius: 6px;
  border: 1px solid #e23130;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  text-align: left;
  img {
    width: 24px;
  }
  .cart {
    background: url("/static/img/dhd.png") no-repeat;
    display: inline-block;
    width: 22px;
    height: 22px;
    background-size: cover;
  }
  // span{
  //   color: #E23130 !important  ;
  //   background: url('/static/img/dhd.png') no-repeat;
  //   display: inline-block;
  //   width: 22px;
  //   height: 22px;
  //   background-size: cover;

  // }
  &:hover {
    background: rgba(226, 49, 48, 0.1);
    border-radius: 6px;
    background: #e23130 !important;
    color: #fff !important;
    border: 1px solid #e23130 !important;
    box-shadow: 1px 1px 12px 0px rgba(110, 110, 110, 0.17);
    span {
      color: #fff !important;
      background: url("/static/img/cart-icon.svg") no-repeat;
    }
    .cart {
      background: url("/static/img/cart-icon.svg") no-repeat;
      display: inline-block;
      width: 22px;
      height: 22px;
      background-size: cover;
    }
  }
}
/deep/.el-tabs--border-card > .el-tabs__content {
  min-height: 400px;
}
/deep/.el-tabs--border-card {
  border: 1px solid #dfdfdf;
  box-shadow: none;
}
// /deep/.el-input-number--small .el-input-number__decrease, /deep/.el-input-number--small .el-input-number__increase {
// width: 32px;
// height: 32px;
// border-radius: 0px 2px 2px 0px;
// border: 1px solid #B9B9B9;
// box-sizing: border-box;
// }
// /deep/.el-input-number .el-input {
//     width: 47px;
// height: 32px;
// border: 1px solid #B9B9B9;
// box-sizing: border-box;
// }
#detail {
  border-bottom: none;
  border-right: none;
  border-left: none;
  .rect {
    width: 25px;
    height: 6px;
    border-radius: 3px;
    margin: 0px auto 0px auto;
  }
  .tips-btn {
    padding: 8px 40px;
  }
  .dialog-title {
    color: #0f2134;
    margin-top: 8px;
    font-size: 16px;
    letter-spacing: 2px;
  }
  padding-bottom: 50px;
  background: #fff;
  .conter {
    zoom: 1;
    background: #fff;
    height: 580px;
    position: relative;
    display: table;
    width: 100%;
    // box-shadow:0px 0px 5px #EEEEEE;
    .top-circle {
      width: 30px;
      height: 45px;
      position: absolute;
      top: -30px;
      left: 485px;
      background: #fff;
      .mask {
        width: 30px;
        height: 30px;
        background: #fff;
        position: absolute;
        bottom: 15px;
        z-index: 120;
      }
      .circle {
        width: 100%;
        height: 30px;
        position: absolute;
        bottom: 0px;
        box-shadow: inset 0px -2px 5px #eeeeee;
        border-radius: 50%;
        z-index: 119;
      }
    }
    .bottom-circle {
      width: 30px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      bottom: -25px;
      left: 485px;
      background: #fff;
      .mask {
        width: 30px;
        height: 25px;
        background: #fff;
        position: absolute;
        top: 15px;
        z-index: 120;
      }
      .circle {
        width: 100%;
        height: 30px;
        position: absolute;
        top: 0px;
        box-shadow: inset 0px 2px 5px #eeeeee;
        border-radius: 50%;
        z-index: 119;
      }
    }
    .el-col {
      height: 100%;
    }
  }
  .goodsimg {
    box-sizing: border-box;
    // padding: 20px;
    .img {
      width: 442px;
      max-width: 442px;
      height: 442px;
      max-height: 442px;
      margin-bottom: 16px;
    }
    .imgbtn,
    .imgbtn {
      color: #fff;
    }
    .imgbtn:hover,
    .imgbtn:hover {
      color: #595959;
    }
  }
  .imgbtn {
    display: inline-block;
    height: 82px;
    margin: 0 0px;
    line-height: 82px;
    background: rgba(38, 38, 38, 0.6);
    // background: #f8f8f8;

    color: #fff;
    widows: 25px;
    //     border: 1px solid #eeeeee;
  }
  .unbtn {
    color: #e8e8e7 !important;
  }
  .evenly {
    justify-content: space-evenly;
  }
  .product_details_img_box {
    // height: 76px;
    box-sizing: border-box;
    overflow: hidden;
    // padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    li {
      // float: left;
      // width: 19%;
      img {
        border: 1px solid #e8e8e8;
        width: 82px;
        max-width: 82px;
        max-height: 82px;
        box-sizing: border-box;
      }
    }
  }
  .product_details {
    // padding: 80px 140px 0 50px;
    .goodsName {
      height: 80px;
      font-size: 24px;
      font-family: MicrosoftYaHei;
      color: #262626;
      line-height: 40px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      cursor: default;
      span {
        cursor: default;
      }
    }
    .goodsid {
      text-align: left;
      font-size: 14px;
      margin-top: 15px;
      height: 19px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #535353;
      line-height: 19px;
    }
    .goodsprice {
      // border-bottom: 1px dashed #979797;
      padding-bottom: 22px;
      // margin: 18px 0 64px 0;
      background: #f5f5f5;
      // background: url(/static/img/priceimg.png);
      display: flex;
      align-items: center;
      cursor: default;
      text-align: left;
      i {
        font-size: 28px;
        margin: 0 10px 0 30px;
      }
      span {
        cursor: default;
        font-size: 30px;
        display: inline;
        // margin: 0 5px;
      }
    }
    button {
      width: 168px;
      height: 48px;
      color: #e23130 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      // >span{
      //    display: flex;
      // }
      // line-height: 42px;
      /deep/ .cart {
        background: url("/static/img/cart-active.svg") no-repeat;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-size: cover;
      }
      &:hover {
        color: #fff !important;
        /deep/ .cart {
          background: url("/static/img/cart-icon.svg") no-repeat;
          display: inline-block;
          width: 22px;
          height: 22px;
          background-size: cover;
        }
      }
    }
    .button1:hover {
      border: 1px solid #e23130 !important;
    }
    button.bottomhs {
      color: #fff !important;
      border: 1px solid rgb(185, 185, 185) !important;
    }
    button.bottomhs :hover {
      color: #fff;
      border: 1px solid rgb(185, 185, 185) !important;
    }
  }
  .hotgoods {
    width: 330px;
    background: white;
    border: 1px solid #e5e5e5;
    // box-shadow:0px 0px 5px #EEEEEE;
    li {
      overflow: hidden;
      border-bottom: 1px dashed #dfdfdf;
    }
    li:last-child {
      border: none;
    }
  }
  .goodsdetail {
    width: 830px;
    background: white;
    // padding:0px 26px 26px 26px;
    // border: 1px solid #DFDFDF;
    // padding:0px 20px 26px 20px;
    // box-sizing: border-box;
  }
  .redline {
    display: block;
    width: 36px;
    height: 6px;
    border-radius: 15px;
    margin: 15px auto;
  }
  .greyline {
    display: inline-block;
    width: 30px;
    height: 2px;
    background: #f3f3f3;
    margin: 0 5px 6px 5px;
  }
  .clear {
    clear: both;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
    background-color: rgba(109, 109, 109, 0.4);
  }
  .login {
    position: fixed;
    top: 30%;
    left: 50%;
    margin-left: -176px;
    z-index: 999;
  }
  .numlist {
    background: url(/static/img/top.png);
    position: absolute;
    // top: 0;
    // left: 5px;
    top: -3px;
    // left: 5px;
    width: 36px;
    height: 36px;
    color: white;
  }
}
/*//地址弹框*/
#detail .siteCont {
  border-top: 1px dashed #979797;
  padding-top: 10px;
  position: relative;
  text-align: left;
  padding-bottom: 22px;
  align-items: center;
}
#detail .sitsPop {
  // width:100%;
  height: 40px;
  background: #fff;
  position: relative;
  z-index: 800;
  margin-top: 10px;
}
.sitsPop-hover .sitelist {
  display: block !important;
}
#detail .el-select {
  width: 120px;
}
#detail .amendinfo {
  position: relative;
  top: 0;
  left: 0;
  z-index: 2010;
  background: transparent;
}
#detail .amendinfo span {
  display: inline-block;
  width: 80px;
  height: 38px;
  background: #fff;
  position: absolute;
  top: 1px;
  line-height: 38px;
  font-size: 14px;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
#detail .pop1 {
  left: 15px;
}
#detail .pop2 {
  left: 140px;
}
#detail .pop3 {
  left: 265px;
}
#detail .pop4 {
  left: 389px;
}
/*//地址弹框*/
.site {
  display: inline-block;
  // margin-right: 20px;
  box-sizing: border-box;
  padding: 0 5px;
  color: #7a7a7a;
  position: relative;
  height: 40px;
  line-height: 40px;
  border: 1px solid #b9b9b9;

  &:hover {
    // background: white;
    border-bottom: none;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -2px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
.active1 {
  border: solid 2px #e23130 !important;
  border-bottom: solid 2px #fff !important;
  position: relative !important;
  &::after {
    content: "";
    width: 100%;
    position: absolute;
    height: 2px;
    bottom: -2px;
    z-index: 10;
    left: 0;
    background: #fff;
  }
}
.sitelist {
  position: absolute;
  top: 39px;
  left: -1px;
  display: none;
  padding: 10px;
  width: 440px;
  min-height: 240px;
  background: white;
  box-shadow: 0px 9px 15px 0px rgba(106, 106, 106, 0.17);
  border: 1px solid #b9b9b9;
  // border: 1px solid #e7e7e7;
  z-index: 99;
  text-align: left;
  .sitenav {
  }
  ul {
    //  border-top: 2px solid #E23130;
    position: relative;
    z-index: 9;
    li {
      display: inline-block;
      //float: left;
      color: #939393;
      min-width: 50px;
      padding: 0px 10px;
      border: none;
      text-align: left;
    }
  }
  span {
    color: #939393;
    display: inline-block;
    padding: 0 10px;
    min-width: 50px;
    // border: solid 1px #b9b9b9;
    border: solid 1px #fff;
    margin-right: 10px;
    border-bottom: none;
    position: relative;
    bottom: -2px;
  }
  .spanBoder {
    border: solid 1px #b9b9b9;
  }
  .active {
    color: #000;
  }
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */

  -webkit-user-select: none; /* Chrome/Safari/Opera */

  -khtml-user-select: none; /* Konqueror */

  -moz-user-select: none; /* Firefox */

  -ms-user-select: none; /* Internet Explorer/Edge */

  user-select: none; /* Non-prefixed version, currently

  not supported by any browser */
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/detail.vue